module.exports = __webpack_public_path__ + "img/20190528162447490.5fb5f097.png";